import { api } from './index';

const ProfilesRequestService = {
  get() {
    return api.get('get-profiles')
  },
  getAll(params) {
    return api.get('profiles/paginated', params);
  },
  getOne(id, params) {
    return api.get('profiles/' + id, params);
  },
  save(params) {
    return api.post('profiles/', params);
  },
  update(id, params) {
    return api.post('profiles/' + id, params);
  },

  getLanguages() {
    return api.get('languages/');
  },
  getAreas() {
    return api.get('areas/');
  },
  getRouteGroups() {
    return api.get('route-groups/');
  },
  getProfileTypes() {
    return api.get('profile-types/');
  },
  getFlows() {
    return api.get('flows/steps/action-status/');
  },
  getSteps(id) {
    return api.get('profiles/' + id + '/steps/');
  },
};

export default ProfilesRequestService;